export default __webpack_public_path__ + "static/media/visitprofile.d7dafb1b.svg";